import { jsx as _jsx } from "react/jsx-runtime";
import { radius, spacing, colors } from '@mehilainen/mds-tokens';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
// NOTE: Do not import these from lib root! Will cause circular deps
import { InfoCircleSolid, Success, Warning, WarningAlt } from './icons';
// NOTE: If the tokens do not contain all values, they must be manually coded into stories that the args cannot be chosen
// * no button large variant, see Button.stories.tsx
// * no chip large variant, see Chip.stories.tsx
// https://zeroheight.com/095c4083c/v/latest/p/61a956-professional
export const professionalTokens = {
    uiElementTypography: {
        dropdownRow: baseTypography.size[300].rem,
        selectorModalTitle: baseTypography.size[300].rem,
        datePickerDate: baseTypography.size[300].rem,
        datePickerColumenTitle: baseTypography.size[200].rem,
    },
    uiElementButton: {
        borderRadius: radius[100].px,
        lightHoverColor: colors.Primary100,
        sizeSmall: {
            fontSize: baseTypography.size[200].rem,
            height: spacing[700].px,
            gap: spacing[250].px,
            padding: spacing[350].px,
            paddingForIcon: spacing[250].px,
        },
        sizeMedium: {
            fontSize: baseTypography.size[300].rem,
            height: spacing[750].px,
            gap: spacing[250].px,
            padding: spacing[400].px,
            paddingForIcon: spacing[300].px,
        },
        sizeLarge: {
            fontSize: baseTypography.size[300].rem,
            height: spacing[800].px,
            gap: spacing[300].px,
            padding: spacing[500].px,
            paddingForIcon: spacing[350].px,
        },
    },
    uiElementInputFields: {
        sizeSmall: {
            notchedLabelFontSize: baseTypography.size[200].rem,
            notchedLabelFontWeight: baseTypography.weight.Regular,
            labelFontSize: baseTypography.size[300].rem,
            labelFontWeight: baseTypography.weight.Medium,
            contentFontSize: baseTypography.size[300].rem,
            assistiveTextSize: baseTypography.size[200].rem,
            assistiveTextWeight: baseTypography.weight.Regular,
            height: spacing[800].rem,
        },
        sizeMedium: {
            notchedLabelFontSize: baseTypography.size[200].rem,
            notchedLabelFontWeight: baseTypography.weight.Regular,
            labelFontSize: baseTypography.size[300].rem,
            labelFontWeight: baseTypography.weight.Medium,
            contentFontSize: baseTypography.size[300].rem,
            assistiveTextSize: baseTypography.size[200].rem,
            assistiveTextWeight: baseTypography.weight.Regular,
            height: spacing[900].rem,
        },
        common: {
            borderRadius: radius[100].pixels,
            borderColor: colors.Gray300,
            labelColor: colors.Gray900,
            labelFilledColor: colors.Gray900,
            labelFocusedColor: colors.Gray900,
            paddingLeft: 12,
            errorBackground: colors.Error100,
        },
    },
    uiElementSelections: {
        iconSize: baseTypography.size.icon[300].rem,
        toggleWidth: spacing[600].rem,
        toggleHeight: '14px',
        thumbSize: '7px',
        labelMarginLeft: spacing[200].px,
        labelSize: baseTypography.size[300].rem,
        labelWeight: baseTypography.weight.Medium,
        subLabelSize: baseTypography.size[200].rem,
        subLabelWeight: baseTypography.weight.Regular,
    },
    uiElementChip: {
        fontWeight: baseTypography.weight.Regular,
        lineHeight: baseTypography.height.Medium,
        borderRadius: radius[100].px,
        gap: '0px',
        icons: {
            padding: spacing[100].px,
        },
        label: {
            padding: spacing[100].px,
        },
        filled: {
            disabled: {
                backgroundColor: colors.Gray[400],
            },
        },
        outlined: {
            borderWidth: '0',
            disabled: {
                backgroundColor: colors.Gray[200],
                color: colors.Gray[400],
            },
        },
        sizeSmall: {
            height: spacing[600].rem,
            fontSize: baseTypography.size[300].rem,
            padding: spacing[200].px,
            icons: {
                size: baseTypography.size.icon[100].rem,
            },
        },
        sizeMedium: {
            fontSize: baseTypography.size[300].rem,
            height: '1.75rem',
            padding: spacing[250].px,
            icons: {
                size: baseTypography.size.icon[200].rem,
            },
        },
    },
    uiElementToggleButton: {
        sizeSmall: {
            height: spacing[600].rem,
            fontSize: baseTypography.size[200].rem,
            padding: spacing[300].rem,
        },
        sizeMedium: {
            height: spacing[700].rem,
            fontSize: baseTypography.size[300].rem,
            padding: spacing[300].rem,
        },
        sizeLarge: {},
    },
    uiElementTabs: {
        fontSize: baseTypography.size[300].rem,
        lineColor: colors.Black,
    },
    uiElementAlert: {
        border: '0',
        borderRadius: '0',
        icon: {
            bgHeight: spacing[800].rem,
            bgWidth: spacing[800].rem,
            borderRadius: radius[200].rem,
            iconMapping: {
                error: _jsx(WarningAlt, {}),
                info: _jsx(InfoCircleSolid, {}),
                success: _jsx(Success, {}),
                warning: _jsx(Warning, {}),
            },
            standard: {
                bgColor: {
                    error: colors.Error500,
                    info: colors.Info500,
                    success: colors.Success500,
                    warning: colors.Warning500,
                },
                color: {
                    error: colors.White,
                    info: colors.White,
                    success: colors.White,
                    warning: colors.White,
                },
            },
            filled: {
                bgColor: colors.White,
                color: {
                    error: colors.Error500,
                    info: colors.Info500,
                    success: colors.Success500,
                    warning: colors.Warning500,
                },
            },
        },
        lineHeight: baseTypography.height.Medium,
        padding: spacing[550].rem,
    },
    uiElementAlertTitle: {
        marginBottom: '0',
    },
    uiElementAccordion: {
        titleFontSize: baseTypography.size[300].rem,
        contentDefaultFontSize: baseTypography.size[200].rem,
        iconSize: spacing[600].rem,
        height: spacing[900].rem,
    },
    values: {
        inputLabelPlacement: 'notched',
    },
};
